export default __webpack_public_path__ + "static/media/room-view.a3181a9e.jpg";